import { useQuery } from '@tanstack/react-query'
import { pb } from '@/lib/pocketbase'

const baseUrl = import.meta.env.VITE_POCKETBASE_URL || 'https://pb.mybooq.ai'

export interface KixBalance {
  available: boolean
  kixBalance?: number
}

// P6: live merged KIX balance, relayed by the Booq backend from the Hellokix shop.
// `available: false` means the user has no shop link yet or the shop is unreachable —
// callers should render a quiet fallback, never an error.
export const useKixBalance = () => {
  return useQuery({
    queryKey: ['kixBalance', pb.authStore.model?.id],
    enabled: pb.authStore.isValid,
    staleTime: 30_000,
    retry: 1,
    queryFn: async (): Promise<KixBalance> => {
      const res = await fetch(`${baseUrl}/api/kix/balance`, {
        headers: { Authorization: `Bearer ${pb.authStore.token}` },
      })
      if (!res.ok) return { available: false }
      return res.json()
    },
  })
}
